import { Container, Distribute } from '@loomhq/lens';
import PropTypes from 'prop-types';
import React from 'react';

type Props = React.PropsWithChildren<{
  height?: number;
  header: React.ReactNode;
  onRightPanel: boolean;
}>;

const RIGHT_PANEL_EXTRA_HEIGHT = 10;
const CONTROL_BAR_OFFSET = 32;
const MIN_HEIGHT = 320;

const SharePageCard = (props: Props): JSX.Element => {
  const { height = 0, children, header, onRightPanel } = props;

  function componentHeight() {
    let calculatedHeight = height;

    if (onRightPanel) {
      calculatedHeight -= RIGHT_PANEL_EXTRA_HEIGHT + CONTROL_BAR_OFFSET;
    }

    return calculatedHeight;
  }

  return (
    <Distribute direction="column">
      <Container borderSide="all" width="100%" radius="medium">
        {header}
        <Container
          borderSide="top"
          minHeight={`${MIN_HEIGHT}px`}
          height={`${componentHeight()}px` || 'auto'}
        >
          {children}
        </Container>
      </Container>
    </Distribute>
  );
};

SharePageCard.propTypes = {
  height: PropTypes.number,
  onRightPanel: PropTypes.bool,
  header: PropTypes.element,
  children: PropTypes.element,
};

export default SharePageCard;
